import React from 'react';
import { cn } from '@shared/ui/utils/tailwind';

export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'fluid';
  className?: string;
};

export const Container: React.FC<ContainerProps> = ({
  size = 'md', className, children, ...props
}) => {
  const sizeClasses = {
    xs: 'max-w-xs', sm: 'max-w-sm', md: 'max-w-3xl', lg: 'max-w-6xl', xl: 'max-w-7xl', fluid: 'max-w-full',
  };

  return (
    <div className={cn('mx-auto px-4', sizeClasses[size], className)} {...props}>
      {children}
    </div>
  );
};

export default Container;
